import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { InputBasicText, InputBasicTextArea, InputSelect2 } from '../../components/common/Inputs';
import { AlertAction, CompanyAction, ProductAction, LicenseAction } from '../../actions';
import { history } from '../../history';
import { FaceAnalyzer, RAYFACE, TEMPS } from '../../config/RayCodes';
import { Modal } from 'react-bootstrap';
import { Translate as t } from '../../config/Translate';
import { isRootCompany } from '../../lib/licenseHelper';
import {
    ProductInfoSite
} from '../../components/product'

const ProductChangeSN = ({ user, GetProduct, site, product, companyList, company, GetCompanyInfo, ShowSaved }) => {

    const [data, setData] = useState({
        newsn: "",
        nowsn: product.sn,
        companyId: product.companyId,
        reason: "",
    });
    const [companies, setCompanies] = useState([]);
    const [ready, setReady] = useState(false);
    const [err, setErr] = useState("");
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [managedGroupInfo, setManagedGroupInfo] = useState({});
    const [hasFaceAnalyzerLicense, setHasFaceAnalyzerLicense] = useState(false);
    const [originalSN, setOriginalSN] = useState(null);

    useEffect(() => {
        if (companyList.length > 0)
            setCompanySelect();
    }, [companyList]);

    const setCompanySelect = () => {
        const cList = [];
        companyList.map((c) => cList.push({ code: c.companyId, title: c.name }));
        setCompanies(cList);
    }

    useEffect(() => {
        setReady(false);
        //GetCompany();
    }, []);

    useEffect(() => {
        setReady(true);
    }, [site]);

    useEffect(() => {
        if (product && product.companyId) {
            GetCompanyInfo(product.companyId);
        }
    }, [product]);

    useEffect(() => {
        if (company && company?._id) {
            getManagerGroupInfoByCompanyId();
        }
    }, [company]);

    const getManagerGroupInfoByCompanyId = async () => {
        let companyId = user?.companyId;
        let managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(companyId, product?.model?.includes('RAYFace') ? 'App-FaceAnalyzer' : 'App-SmartDentFiveD');
        if(managerGroupInfo.length == 0) {
            const parentCompanyId = await CompanyAction.GetParents("");
            if (parentCompanyId.length === 1 && parentCompanyId[0].code === companyId) {
                companyId = companyId;
            } else {
                companyId = parentCompanyId.find(x => x.code !== companyId && x?.org === "Branch" && isRootCompany(x))?.code;
            }
            managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(companyId, product?.model?.includes('RAYFace') ? 'App-FaceAnalyzer' : 'App-SmartDentFiveD');
        }
        setManagedGroupInfo(managerGroupInfo);
    };

    const changeSn = async () => {
        // Check if original SN has prdType 'expert' and Face Analyzer license
        const currentSN = product.sn;
        let hasLicense = false;
        
        if (product.prdtype === 'expert') {
            const licenseSN = await LicenseAction.GetLicenseSN({sn: currentSN});
            if (licenseSN && licenseSN._id === FaceAnalyzer.appId) {
                hasLicense = true;
                setHasFaceAnalyzerLicense(true);
                setOriginalSN(currentSN);
                // Show warning modal
                setShowWarningModal(true);
                return;
            }
        }

        // Proceed with SN change
        setHasFaceAnalyzerLicense(hasLicense);
        setOriginalSN(currentSN);
        await proceedWithSNChange(hasLicense, currentSN);
    }

    const proceedWithSNChange = async (hasFaceAnalyzerLicense = false, originalSN = null) => {
        const newSN = data.newsn.toUpperCase().trim();
        const currentSN = originalSN || product.sn;
        
        const ret = await ProductAction.ChangeSN(product._id, { ...data, newsn: newSN });
        if (ret.data.status == 'success') {
            ShowSaved();
            // Create Face Analyzer license for new SN if original had expert prdType and Face Analyzer license
            if (hasFaceAnalyzerLicense || (product.prdtype === 'expert' && currentSN)) {
                if (!hasFaceAnalyzerLicense) {
                    const originalLicenseSN = await LicenseAction.GetLicenseSN({sn: currentSN});
                    hasFaceAnalyzerLicense = (originalLicenseSN && originalLicenseSN._id === FaceAnalyzer.appId);
                }
                if (hasFaceAnalyzerLicense) {
                    await createFaceAnalyzerLicenseForNewSN(newSN);
                }
            }
            GetProduct(ret.data.data.sn)
            history.push("/Admin/AdminProductInfo/" + ret.data.data.sn);
        } else {
            if (ret.data.errmsg == "ER0091") {
                setErr("Already Exist - New SN : " + data.newsn);
            }
        }
    }

    const createFaceAnalyzerLicenseForNewSN = async (newSN) => {
        try {
            const pid = product?.model?.toUpperCase().includes(RAYFACE) ? FaceAnalyzer.pid : null;
            if (!pid) return;

            const checkFireStoreSN = await LicenseAction.CheckFireStoreSN(newSN);
            let updateParams = {};
            if(!checkFireStoreSN) {
                updateParams = {
                    sn: newSN,
                    appId: FaceAnalyzer.appId,
                    lcType: "package",
                    created: Date.now(),
                    creator: user?._id || "",
                    groupId: TEMPS.TEMPGroup,
                    ntid: TEMPS.TEMPNtId,
                    mgroupid: managedGroupInfo?.sk?.split(":")[1] || TEMPS.TEMPMGroupId,
                    userId: TEMPS.TEMPUser,
                    pid: pid
                }
            } else {
                updateParams = {
                    sn: newSN,
                    appId: FaceAnalyzer.appId,
                    lcType: "package",
                    created: Date.now(),
                    creator: user?._id || "",
                    groupId: checkFireStoreSN?.groupId || TEMPS.TEMPGroup,
                    ntid: checkFireStoreSN?.networkId || TEMPS.TEMPNtId,
                    mgroupid: managedGroupInfo?.sk?.split(":")[1] || TEMPS.TEMPMGroupId,
                    userId: TEMPS.TEMPUser,
                    pid: pid
                };
            }
            await LicenseAction.CreateLicenseSN(updateParams);
        } catch (error) {
            console.log("createFaceAnalyzerLicenseForNewSN error:", error);
        }
    }

    return (
        <>
            {product.siteId && (
                <>
                    <div className="section mt-2 mb-2">
                        <div className="card bg-danger text-white">
                            <div className="card-header">
                                <div className="card-title">{t('common.label.warning')}</div>
                            </div>
                            <div className="card-body">
                                <h4 className="text-white">{t('product.changeSn.siteInstalledWarning')}</h4>
                            </div>
                        </div>
                    </div>
                    <ProductInfoSite product={product} showtitle={false} />
                </>
            )}
            {!product.siteId && (
                <>
                    <div className="section mt-2 mb-2">
                        {err && <div className="mb-1"><span className="alert alert-danger">{t('product.changeSn.alreadyExists')}</span></div>}
                        <div className="card bg-danger text-white">
                            <div className="card-header">
                                <div className="card-title">{t('common.label.warning')}</div>
                            </div>
                            <div className="card-body">
                                <h4 className="text-white">{t('product.updateSite.appliedImmediately')}</h4>
                                <div className="text-white">
                                    <p className="text-white">{t('product.confirm.irreversible')} {t('product.changeSn.irreversibleNote')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section">
                        <div className="card">
                            <div className="card-body">

                                <InputBasicText
                                    options={{
                                        name: 'newsn',
                                        label: t('product.field.newSn'),
                                        size: 12,
                                        val: data.newsn,
                                        required: true
                                    }}
                                    onchange={(e) => setData({ ...data, newsn: e.target.value })}
                                    editable={true} />

                                <InputSelect2
                                    options={{
                                        name: "companyId",
                                        label: t('product.field.transferCompany'),
                                        val: data.companyId,
                                        list: companies,
                                    }}
                                    onchange={(e) => setData({ ...data, companyId: e.target.value })}
                                    editable={true} />

                                <InputBasicTextArea
                                    options={{
                                        name: 'reason',
                                        label: t('common.field.reason'),
                                        val: data.reason,
                                        required: true
                                    }}
                                    onchange={(e) => setData({ ...data, reason: e.target.value })}
                                    editable={true} />
                            </div>
                        </div>
                        {(data.newsn && data.reason) && <button className="btn btn-outline-danger" onClick={() => changeSn()}>{t('product.button.changeSn')}</button>}
                        {!(data.newsn && data.reason) && <button className="btn btn-outline-danger disabled" onClick={() => changeSn()}>{t('product.button.changeSn')}</button>}
                    </div>
                </>
            )}

            <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)}>
                <Modal.Header>
                    <Modal.Title>{t('common.label.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t('product.changeSn.faceAnalyzerExists')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={() => {
                        setShowWarningModal(false);
                        proceedWithSNChange(hasFaceAnalyzerLicense, originalSN);
                    }}>
                        {t('common.button.continue')}
                    </button>
                    <button className="btn btn-secondary" onClick={() => setShowWarningModal(false)}>
                        {t('common.button.cancel')}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.ProductReducer.isUpdateRes;
    const companyList = state.CompanyReducer.companies;
    const site = state.SiteReducer.site;
    const user = state.AuthReducer.user;
    const company = state.CompanyReducer.company;
    return { site, user, isUpdateRes, companyList, company };
}

const mapDispatch = dispatch => ({
    //GetCompany: () => dispatch(CompanyAction.GetCompany()),
    GetProduct: (sn) => dispatch(ProductAction.GetProduct(sn)),
    GetCompanyInfo: (companyId) => dispatch(CompanyAction.GetCompanyInfo(companyId)),
    ShowSaved: () => dispatch(AlertAction.Success(t('common.message.success.saved'))),
    //ClearUpdateResult : () => dispatch(ProductAction.ClearUpdateResult()),
    //DeleteProduct : (_id) => dispatch(ProductAction.DeleteProduct(_id))
})

export default connect(mapState, mapDispatch)(ProductChangeSN);